import { render } from "./CreatePostForm.vue?vue&type=template&id=7e62f22f"
import script from "./CreatePostForm.vue?vue&type=script&lang=js"
export * from "./CreatePostForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__